<template>
  <div class="user-bd" :class="{ 'crm-user': !!orgId }">
    <div class="tb-box-bd">
      <div class="search-hd">
        <el-form :inline="true" @submit.native.prevent>
          <el-form-item v-if="funcView.user_add || !!orgId">
            <el-button type="primary" @click="onAddUser()">
              <i class="icon icon-add"></i>
              {{ $t('Common.com_add') }}
            </el-button>
          </el-form-item>
          <el-form-item v-if="funcView.user_disable || !!orgId">
            <el-button type="primary" @click="setUserStatus()" :disabled="!tableSelect.length">
              <i class="icon icon-jinyong1"></i>
              {{ $t('Common.com_disable') }}
            </el-button>
          </el-form-item>
          <el-form-item v-if="funcView.user_enable || !!orgId">
            <el-button type="primary" @click="setUserStatus(true)" :disabled="!tableSelect.length">
              <i class="icon icon-qiyong"></i>
              {{ $t('Common.com_enable') }}
            </el-button>
          </el-form-item>
          <!-- 这个权限还要么，简版不控制了 funcView.user_set_admin -->
          <el-form-item v-if="!!orgId">
            <el-button type="primary" :disabled="selectedRow ? !selectedRow.userId || !!selectedRow.isAdmin : false" @click="setAdminUser">{{ $t('base_user.she_wei_guan_li_yuan') }}</el-button>
          </el-form-item>
          <el-form-item style="float: right; margin-right: 0">
            <custom-column ref="column"></custom-column>
          </el-form-item>
          <el-form-item style="float: right">
            <search-input :placeholder="$t('base_user.ygxmdlzhlxdhyx')" v-model="formSearch.search" @fetch="onPageChange({ page: 1 })"></search-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="table-bd">
        <custom-table
          v-if="funcView.user_list || !!orgId"
          tableCode="user_manage"
          type="radioCheckbox"
          v-model="tableSelect"
          :data="userList"
          @filter="filterChange"
          @sort="sortChange"
          @radio="onCurrentRow"
          @column="setColumn"
          height="100%"
        >
          <el-table-column :label="$t('Common.com_handle')" min-width="170" fixed="right">
            <template slot-scope="scope" v-if="!(isCurrentOrg && scope.row.isAdmin)">
              <el-button v-if="funcView.user_edit || !!orgId" @click="onEditUser(scope.row)" type="text" size="mini">{{ $t('Common.com_edit') }}</el-button>
              <template v-if="currentUserId !== scope.row.userId">
                <el-button v-if="funcView.user_rest_pwd || !!orgId" @click="resetPassword(scope.row.userId)" type="text" size="mini">{{ $t('base_user.zhong_zhi_mi_ma') }}</el-button>
                <el-button v-if="scope.row.state === 1 && (funcView.user_disable || !!orgId)" @click="setItemUserStatus(scope.row.userId)" type="text" size="mini">{{ $t('Common.com_disable') }}</el-button>
                <el-button v-if="scope.row.state !== 1 && (funcView.user_enable || !!orgId)" @click="setItemUserStatus(scope.row.userId, true)" type="text" size="mini">
                  {{ $t('Common.com_enable') }}
                </el-button>
              </template>
            </template>
          </el-table-column>
        </custom-table>
      </div>
      <div class="table-page" v-if="funcView.user_list || !!orgId">
        <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
      </div>
    </div>
    <div v-if="!!orgId" style="height: 16px; background-color: #e4ebf2; margin: -16px 0 0"></div>
    <!-- 关联信息 -->
    <div class="tb-box" style="background-color: #ffffff">
      <custom-tab v-model="currentTab" :list="tabList"></custom-tab>
      <div class="tab-box">
        <user-role ref="role" v-if="currentTab === 'tab1'" :userId="selectedRow.userId" :userName="selectedRow.userName" :orgId="orgId"></user-role>
        <user-organ ref="organ" v-if="currentTab === 'tab2'" :userId="selectedRow.userId" :orgId="orgId"></user-organ>
        <user-device ref="device" v-if="currentTab === 'tab3'" :userId="selectedRow.userId" :orgId="orgId"></user-device>
        <user-distribution ref="distribution" v-if="currentTab === 'tab4'" :userId="selectedRow.userId" :orgId="orgId"></user-distribution>
        <user-location ref="location" v-if="currentTab === 'tab5'" :userId="selectedRow.userId" :orgId="orgId"></user-location>
      </div>
    </div>
    <!-- 密码重置 -->
    <reset-pwd-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false"></reset-pwd-dialog>
  </div>
</template>
<script>
import apis from '@/utils/apis';
import resetPwdDialog from './children/reset_pwd_dialog';
import userRole from './children/user_role';
import userOrgan from './children/user_organ';
import userDevice from './children/user_device';
import userDistribution from './children/user_distribution';
import userLocation from './children/user_location';

export default {
  name: 'user',
  components: { resetPwdDialog, userRole, userOrgan, userDevice, userDistribution, userLocation },
  props: {
    orgId: [String, Number],
    orgBy: String,
  },
  data() {
    return {
      tableSelect: [],
      selectedRow: {},
      formSearch: {
        orgId: this.orgId,
        search: '',
        orderBy: '',
        orderType: '',
        pageSize: 20,
        pageNum: 1,
      },
      dialogVisible: false,
      dialogModel: {},
      currentTab: '',
      userList: [],
      totalRows: 0,
    };
  },
  computed: {
    // 是否总部等
    isGroupOrgan() {
      const userInfo = this.$store.state.userInfo || {};
      const bizType = this.getJump('bizType') || userInfo.bizType;
      return ['HQ', 'JV_SC', 'CO', 'JV'].includes(bizType);
    },
    isCurrentOrg() {
      const userInfo = this.$store.state.userInfo || {};
      return this.orgId ? userInfo.rootOrgId === this.orgId : true;
    },
    currentUserId() {
      const userInfo = this.$store.state.userInfo || {};
      return userInfo.userId;
    },
    tabList() {
      const list = [
        {
          name: this.$t('base_user.gang_wei'), // 员工岗位
          value: 'tab1',
          code: 'user_role_list',
        },
        {
          name: this.$t('base_user.bu_men'), // 员工部门
          value: 'tab2',
          code: 'user_department_list',
        },
        {
          name: this.$t('base_user.ji_qi_fen_pei'), // 员工设备关系
          value: 'tab4',
          code: this.isGroupOrgan ? 'user_devices_page' : '',
        },
        {
          name: this.$t('base_user.ji_qi'), // 员工设备
          value: 'tab3',
          code: 'user_device_list',
        },
        {
          name: this.$t('base_user.xiang_mu'), // 员工项目
          value: 'tab5',
          code: 'user_location_list',
        },
      ];
      return list.filter((t) => !!this.funcView[t.code] || !!this.orgId);
    },
  },
  mounted() {
    this.getFuncView('/company/user', () => {
      this.currentTab = this.tabList[0] && this.tabList[0].value;
    });
    this.getUserPage();
  },
  methods: {
    onAddUser: function () {
      this.clearTagByKeep('user_item');
      if (this.orgBy === 'serviceCompany') {
        const companyId = this.getJump('companyId');
        const bizType = this.getJump('bizType');
        this.jump('/redirect/distributor/serviceCompany/adduser', { orgId: this.orgId, bizType, parentPath: `/distributor/serviceCompany/detail?tab=user&companyId=${companyId}&bizType=${bizType}` });
        return;
      } else if (this.orgBy === 'factory') {
        const factoryId = this.getJump('factoryId');
        const bizType = this.getJump('bizType');
        this.jump('/redirect/distributor/factory/adduser', { orgId: this.orgId, bizType, parentPath: `/distributor/factory/detail?tab=user&factoryId=${factoryId}&bizType=${bizType}` });
        return;
      } else if (this.orgBy === 'renter') {
        const renterId = this.getJump('renterId');
        const bizType = this.getJump('bizType');
        this.jump('/redirect/customer/renter/adduser', { orgId: this.orgId, bizType, parentPath: `/customer/renterDetail?tab=user&renterId=${renterId}&bizType=${bizType}` });
        return;
      } else if (this.orgBy === 'groupCustomer') {
        const groupCustomerId = this.getJump('groupCustomerId');
        const bizType = this.getJump('bizType');
        this.jump('/redirect/customer/groupCustomer/adduser', {
          orgId: this.orgId,
          bizType,
          parentPath: `/customer/groupCustomer/detail?tab=user&groupCustomerId=${groupCustomerId}&bizType=${bizType}`,
        });
        return;
      }
      const bizType = this.getJump('bizType');
      this.jump('/redirect/company/user/add', { orgId: this.orgId, bizType, parentPath: '/company/user' });
    },
    onEditUser: function (row) {
      this.clearTagByKeep('user_item');
      if (this.orgBy === 'serviceCompany') {
        const companyId = this.getJump('companyId');
        const bizType = this.getJump('bizType');
        this.jump('/redirect/distributor/serviceCompany/edituser', {
          orgId: this.orgId,
          bizType,
          userId: row.userId,
          parentPath: `/distributor/serviceCompany/detail?tab=user&companyId=${companyId}&bizType=${bizType}`,
        });
        return;
      } else if (this.orgBy === 'factory') {
        const factoryId = this.getJump('factoryId');
        const bizType = this.getJump('bizType');
        this.jump('/redirect/distributor/factory/edituser', {
          orgId: this.orgId,
          bizType,
          userId: row.userId,
          parentPath: `/distributor/factory/detail?tab=user&factoryId=${factoryId}&bizType=${bizType}`,
        });
        return;
      } else if (this.orgBy === 'renter') {
        const renterId = this.getJump('renterId');
        const bizType = this.getJump('bizType');
        this.jump('/redirect/customer/renter/edituser', { orgId: this.orgId, bizType, userId: row.userId, parentPath: `/customer/renterDetail?tab=user&renterId=${renterId}&bizType=${bizType}` });
        return;
      } else if (this.orgBy === 'groupCustomer') {
        const groupCustomerId = this.getJump('groupCustomerId');
        const bizType = this.getJump('bizType');
        this.jump('/redirect/customer/groupCustomer/edituser', {
          orgId: this.orgId,
          bizType,
          userId: row.userId,
          parentPath: `/customer/groupCustomer/detail?tab=user&groupCustomerId=${groupCustomerId}&bizType=${bizType}`,
        });
        return;
      }
      const bizType = this.getJump('bizType');
      this.jump('/redirect/company/user/edit', { userId: row.userId, bizType, parentPath: '/company/user' });
    },
    //  设置管理员
    setAdminUser: function () {
      const tips = this.$t('base_user.nqdyjgygoszwglym', [this.selectedRow.userName]);
      this.$showConfirm(tips)
        .then(() => {
          this.$postJSON(apis.partnerOrganAdminUpdate, {
            newAdminId: this.selectedRow.userId,
            organId: this.orgId,
          }).then(() => {
            this.$message({
              message: this.$t('Common.com_handle_success'),
              type: 'success',
            });
            this.getUserPage();
          });
        })
        .catch(() => {});
    },
    // 获取用户列表
    getUserPage: function () {
      this.$getJSON(apis.UserPage, this.formSearch).then((res) => {
        this.selectedRow = {};
        this.userList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 选中行
    onCurrentRow: function (row) {
      this.selectedRow = row || {};
    },
    // 批量修改用户状态弹窗
    setUserStatus: function (status) {
      if (status) {
        this.$showConfirm(this.$t('base_user.nqdyqyxzdygm'))
          .then(() => {
            const ids = this.tableSelect.map((t) => t.userId);
            this.changeUserStatus(ids, 1);
          })
          .catch(() => {});
      } else {
        this.$showConfirm(this.$t('base_user.nqdyjyxzdygm'))
          .then(() => {
            const ids = this.tableSelect.map((t) => t.userId);
            this.changeUserStatus(ids, 2);
          })
          .catch(() => {});
      }
    },
    // 修改用户状态弹窗
    setItemUserStatus: function (id, status) {
      if (status) {
        this.$showConfirm(this.$t('base_user.nqdyqyxzdygm'))
          .then(() => {
            this.changeUserStatus([id], 1);
          })
          .catch(() => {});
      } else {
        this.$showConfirm(this.$t('base_user.nqdyjyxzdygm'))
          .then(() => {
            this.changeUserStatus([id], 2);
          })
          .catch(() => {});
      }
    },
    // 修改用户状态(1激活，2.禁用， 3.删除)
    changeUserStatus: function (ids, state) {
      this.$postJSON(apis.UserState, { ids: ids, state: state }).then(() => {
        this.$message({
          message: this.$t('Common.com_edit_success'),
          type: 'success',
        });
        this.getUserPage();
      });
    },
    // 重置密码
    resetPassword: function (userId) {
      this.dialogModel.title = this.$t('base_user.zhong_zhi_mi_ma');
      this.dialogModel.data = userId;
      this.dialogVisible = true;
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getUserPage();
    },
  },
};
</script>
<style lang="scss">
@import '@/style/mixin.scss';

.user-bd {
  margin: 16px;
  &.crm-user {
    margin: 0;
  }

  .tb-box-bd {
    display: flex;
    flex-direction: column;
    padding: 0 16px;
    background-color: #ffffff;
    height: 500px;
    margin-bottom: 16px;
  }
  .tab-box {
    padding: 0 16px;
  }
}
</style>
